export default __webpack_public_path__ + "static/media/coin_doge.be9bf901.svg";